import * as fetch from "../../common/fetch";

import type {
  RoleCreateRequestType,
  RoleUpdateRequestType,
  RoleDeleteRequestType
} from "../requests/roleRequestTypes";

import { UserGetRolesResponseType } from "../responses/userResponseTypes";
import { GroupGetRolesResponseType } from "../responses/groupResponseTypes";
import { PolicyGetRolesResponseType } from "../responses/policyResponseTypes";

import type {
  RoleGetResponseType,
  RoleGetAllResponseType
} from "../responses/roleResponseTypes";

const url = process.env.WIB_API_URL;

export async function getAll() {
  const response = await fetch.get(`${url}/roles`);

  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as RoleGetAllResponseType;
  }
}

export async function getById(id) {
  const response = await fetch.get(`${url}/roles/${id}`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as RoleGetResponseType;
  }
}

export async function getUsers(id) {
  const response = await fetch.get(`${url}/roles/${id}/users`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as UserGetRolesResponseType;
  }
}

export async function getGroups(id) {
  const response = await fetch.get(`${url}/roles/${id}/groups`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as GroupGetRolesResponseType;
  }
}

export async function getPolicies(id) {
  const response = await fetch.get(`${url}/roles/${id}/policies`);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as PolicyGetRolesResponseType;
  }
}

export async function create(body: RoleCreateRequestType) {
  const response = await fetch.post(`${url}/roles`, body);
  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as RoleGetResponseType;
  }
}

export async function update(id, body: RoleUpdateRequestType) {
  const response = await fetch.put(`${url}/roles/${id}`, body);
  return response.ok;
}

export async function del(id, body: RoleDeleteRequestType) {
  const response = await fetch.del(`${url}/roles/${id}`, body);
  return response.ok;
}
